export default "\n\n<mat-label style=\"text-align:center;font-size: 25px;\"><p>Unauthorized Access</p></mat-label>"